import React from 'react'
import { useQueryParam, useViewport } from '@chilecompra/react-kit'
import { Typography, Toast } from '@chilecompra/react-kit/components'
import { Root } from './CertificateHeadingSection.styles'
import { Link } from '../PartnershipGridSection/PartnershipGridSection.styles'
import { REACT_APP_FEATURE_FLAG_MESSAGE_INFO } from '../../config/settings/environment'
/**
 * The Certificate HeadingSection's container.
 */
const CertificateHeadingSection = () => {
  const {
    size: { isDownToSmall }
  } = useViewport()
  const numAcquisition = useQueryParam('numAdquisicion')
  return (
    <Root>
      {REACT_APP_FEATURE_FLAG_MESSAGE_INFO === 'true' && (
        <Toast margin="18px 0 0" severity="warning">
          Por un problema originado en la fuente oficial,{' '}
          <strong>
            no se encuentra disponible en el Registro de Proveedores la información actualizada sobre deudas
            previsionales y de salud
          </strong>
          . Se recomienda solicitar a sus proveedores una Declaración Jurada y otros antecedentes que considere
          pertinentes. Puede utilizar el formato disponible en nuestro&nbsp;
          <Link
            textDecoration
            href="https://ayuda.mercadopublico.cl/material/?c=3df31e42-9b52-ee11-be6f-000d3a88f7bc"
            rel="noreferrer"
            target="_blank"
          >
            Centro de Ayuda.
          </Link>
        </Toast>
      )}
      {numAcquisition ? (
        <Typography align="center" fontWeight="bold" margin="32px 0 24px" variant="h1">
          Certificado de Estado de Habilidad&nbsp;
          {!isDownToSmall && <br />}
          en Registro de Proveedores
        </Typography>
      ) : (
        <Typography align="center" fontWeight="bold" margin="32px 0 24px" variant="h1">
          Certificado de Habilidad&nbsp;
          {!isDownToSmall && <br />}
          Registro de Proveedores
        </Typography>
      )}
    </Root>
  )
}

export default CertificateHeadingSection
